class ProductDescriptionBlock {
  constructor(el) {
    this.el = el;
    this.content = el.querySelector('.product-description');
    this.modeDesktop = el.dataset.modeDesktop || 'full';
    this.modeMobile = el.dataset.modeMobile || 'full';
    this.openByDefault = el.dataset.open === 'true';
    this.labelDescription = el.dataset.labelDescription || '';
    this.labelReadMore = el.dataset.labelReadMore || '';
    this.labelReadLess = el.dataset.labelReadLess || '';
    this._iconSource = el.querySelector('.pd-accordion__icon-source');

    this._mq = window.matchMedia('(min-width: 769px)');
    this._currentMode = null;
    this._cleanup = null;

    this._mq.addEventListener('change', () => this._apply());
    this._apply();
  }

  get _mode() {
    return this._mq.matches ? this.modeDesktop : this.modeMobile;
  }

  _apply() {
    const mode = this._mode;
    if (mode === this._currentMode) return;
    this._destroy();
    this._currentMode = mode;
    this.el.dataset.mode = mode;
    if (mode === 'accordion') this._initAccordion();
    else if (mode === 'truncated') this._initTruncated();
  }

  _initAccordion() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pd-accordion__toggle';
    btn.setAttribute('aria-expanded', String(this.openByDefault));

    const titleEl = document.createElement('span');
    titleEl.className = 'pd-accordion__title font-body font-bold text-body';

    if (this._iconSource) {
      const icon = this._iconSource.cloneNode(true);
      icon.hidden = false;
      icon.removeAttribute('aria-hidden');
      icon.setAttribute('aria-hidden', 'true');
      icon.className = 'pd-accordion__icon';
      titleEl.appendChild(icon);
    }

    titleEl.appendChild(document.createTextNode(this.labelDescription));

    const chevron = document.createElement('span');
    chevron.className = 'pd-accordion__chevron';
    chevron.setAttribute('aria-hidden', 'true');

    btn.appendChild(titleEl);
    btn.appendChild(chevron);

    this.content.classList.add('pd-accordion__content');

    if (!this.openByDefault) {
      this.content.style.height = '0';
    }

    const toggle = () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));

      if (isOpen) {
        this.content.style.height = this.content.scrollHeight + 'px';
        this.content.offsetHeight;
        this.content.style.height = '0';
      } else {
        const h = this.content.scrollHeight;
        this.content.style.height = h + 'px';
        this.content.addEventListener('transitionend', () => {
          if (btn.getAttribute('aria-expanded') === 'true') {
            this.content.style.height = '';
          }
        }, { once: true });
      }
    };

    btn.addEventListener('click', toggle);
    this.el.insertBefore(btn, this.content);

    this._cleanup = () => {
      btn.removeEventListener('click', toggle);
      btn.remove();
      this.content.classList.remove('pd-accordion__content');
      this.content.style.height = '';
    };
  }

  _initTruncated() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pd-read-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = this.labelReadMore;

    const toggle = () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.textContent = expanded ? this.labelReadMore : this.labelReadLess;
      this.el.classList.toggle('is-expanded', !expanded);
    };

    btn.addEventListener('click', toggle);
    this.content.after(btn);

    requestAnimationFrame(() => {
      if (this.content.scrollHeight <= this.content.clientHeight) {
        btn.hidden = true;
      }
    });

    this._cleanup = () => {
      btn.removeEventListener('click', toggle);
      btn.remove();
      this.el.classList.remove('is-expanded');
    };
  }

  _destroy() {
    if (this._cleanup) {
      this._cleanup();
      this._cleanup = null;
    }
    delete this.el.dataset.mode;
    this._currentMode = null;
  }
}

document.querySelectorAll('[data-product-description-block]').forEach(
  el => new ProductDescriptionBlock(el)
);
